import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  Label,
  Row,
  Nav,
  NavItem,
  CardTitle,
  Spinner,
} from "reactstrap";

import { getUserProfile } from "../../../helpers/functions_helper";

import { initialValues } from "../config/initialValues";
import immigrationService from "../services/service";

import "./styles.css";
import ProfileInfo from "./ProfileInfo";
import ImmigrationInfo from "./ImmigrationInfo";
import { ImmigrationDataType } from "../types";
import { mapImmigrationToForm } from "../mappers/mapper";
import Alerts from "./Alerts";

interface LocationState {
  immigrationData?: ImmigrationDataType;
}

const FormComponent = (props: any) => {
  const { id, immigration_id } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get("from");
  const moduleAccess = getUserProfile("immigration");

  const toastId = React.useRef(null) as any;

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState<any>(initialValues);

  const [activeApplicationId, setActiveApplicationId] = useState<number | null>(null);
  const [activeSection, setActiveSection] = useState("Application");

  const loadFormData = async () => {
    setLoading(true);

    const res = await immigrationService.get({ id, immigration_id });

    if (res.data.status === "success") {
      const mapped = mapImmigrationToForm(res.data.data);

      setValues((prev: any) => ({
        ...prev,
        ...mapped,
      }));
    }

    setLoading(false);
  };

  useEffect(() => {
    // Check if data was passed via navigation state
    if (state?.immigrationData) {
      // console.log("Using passed state data");
      const mapped = mapImmigrationToForm(state.immigrationData);

      setValues((prev: any) => ({
        ...prev,
        ...mapped,
      }));

      // No API call needed - data is already loaded
      setLoading(false);
    } else if (id && immigration_id) {
      // console.log("No state data, loading profile data.");
      // Only fetch if no data was passed
      loadFormData();
    }
  }, [state, id, immigration_id]);

  useEffect(() => {
    if (values?.applications?.length > 0) {
      setActiveApplicationId(values.applications[0].id);
    }
  }, [values?.applications]);

  return (
    <React.Fragment>
      <Row className="profile-layout">
        {/* Left Sidebar - Profile Info */}
        <ProfileInfo
          data={values}
          activeApplicationId={activeApplicationId}
          setActiveApplicationId={setActiveApplicationId}
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />

        {/* Middle Content - Immigration Info */}
        <ImmigrationInfo
          data={values}
          activeApplicationId={activeApplicationId}
          activeSection={activeSection}
        />

        {/* Right Content - Notifications */}
        <Alerts />
      </Row>
    </React.Fragment>
  );
};

export default FormComponent;
